// extracted by mini-css-extract-plugin
export var cards = "styles-module--cards--90d44";
export var dashboard = "styles-module--dashboard--35189";
export var double = "styles-module--double--111e1";
export var primary = "styles-module--primary--8674c";
export var triple = "styles-module--triple--ca0a1";